<template>
  <div class="c-link-list__item c-link-list__item--spacer"></div>
</template>

<script>
export default {
  name: 'CIS-Footer-NavList-Spacer',
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss">
.c-footer__nav .c-nav__list {
  .c-link-list__item--spacer {
    min-height: 1em;
  }
}
</style>
